import { pluralize } from '@r1-frontend/shared/helpers/pluralize';
import { monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';
import { EPriceTypes } from '@r1-frontend/shared/types/EPriceTypes';
import React, { PureComponent } from 'react';

import RequestForm from '~/src/components/Equipment/form/requestForm';

import * as ST from './styled';

class OrderPopup extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { label: '' };
        this.onCloseWrapper = this.onCloseWrapper.bind(this);
    }

    setExtParams = () => {
        const { selectRouter } = this.props;

        if (selectRouter) {
            const { materialsEnsId, global_id } = selectRouter.router;
            const { type, value } = selectRouter.option;

            const extParams = {
                tv_equipment_id: materialsEnsId || global_id,
                tv_equipment_buy: type === EPriceTypes.Possess ? 'sale' : 'leasing',
            };

            if (type === EPriceTypes.Possess) {
                extParams.tv_equipment_buy = 'sale';
            } else {
                extParams.tv_equipment_buy = 'leasing';
                extParams.tv_equipment_duration = value;
            }

            return extParams;
        }
    };

    componentDidUpdate() {
        const { selectedOption, selectRouter } = this.props;
        if (selectRouter || selectedOption) {
            const { value, type } = selectedOption || selectRouter?.option;
            this.setState({
                label: `${this.getRouterName()} | ${this.getTypeOfBuy({ type, value })}`,
            });
        }
    }

    getTypeOfBuy = ({ type, value }) => {
        return type === EPriceTypes.Possess ? 'Покупка' : `Рассрочка на ${value} ${pluralize(value, monthPluralize)}`;
    };

    getRouterName = () => {
        const { name, selectRouter } = this.props;
        return name || selectRouter?.router?.materialsEnsName || selectRouter?.router?.title;
    };

    onCloseWrapper = () => {
        const { closeClick } = this.props;
        closeClick();
    };

    renderOrderLine = () => {
        const { selectedOption, selectRouter } = this.props;
        if (selectRouter || selectedOption) {
            const { price, value, type, pricePromo } = selectedOption || selectRouter?.option;

            return <ST.OrderLine data-test='order-options'>
                <div data-test='order-type'>
                    {this.getTypeOfBuy({ type, value })}
                </div>
                <ST.OrderPrice>
                    <ST.Price data-test='order-price'>{pricePromo || price}</ST.Price>
                    <ST.OrderPriceInfo>{type === EPriceTypes.Possess ? '₽' : '₽/мес'}</ST.OrderPriceInfo>
                </ST.OrderPrice>
            </ST.OrderLine>;
        }
    };

    render() {
        const {
            isOpened,
            sendRequest,
            formRef,
            extParams,
            isPopup,
            extLabel,
            isAuth,
            agreement,
            text = 'Стоимость доставки платная. Оставьте заявку, и&nbsp;мы&nbsp;вам перезвоним для уточнения деталей.',
        } = this.props;

        const { label } = this.state;

        return (
            <ST.Popup isOpen={isOpened} onClose={this.onCloseWrapper}>
                <ST.PopupContainer>
                    <ST.PopupHeader>
                        <ST.PopupEquip data-test='router-name'>{this.getRouterName()}</ST.PopupEquip>
                        <ST.PopupTitle>Оформление заявки на заказ</ST.PopupTitle>
                    </ST.PopupHeader>
                    <ST.PopupBody>
                        {this.renderOrderLine()}
                        <ST.FormTitle dangerouslySetInnerHTML={{ __html: text }}/>
                        <RequestForm
                            sendRequest={sendRequest}
                            extParams={extParams || this.setExtParams()}
                            formRef={formRef}
                            textButton='Отправить заявку'
                            option={extLabel || label}
                            isPopup={isPopup}
                            isAuth={isAuth}
                            agreement={agreement}
                        />
                    </ST.PopupBody>
                </ST.PopupContainer>
            </ST.Popup>
        );
    }
}

export default OrderPopup;
